module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-linen-025-1200x2490.9f2f6c82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-linen-025-1200x2490.jpg
// module id = 1108
// module chunks = 37